export const SELECT_ALL_OPTION_ID = 'RR__SELECT_ALL_OPTION_ID';
